<template>
<default-layout>
  <event-navbar title="ZP Event App" :show-back="false" />
  <div class="home">
    <v-runtime-template :template="home_content" ></v-runtime-template>
    <hr class="mx-3">
    <p class="text-center text-muted small mb-4">
      <router-link to="/about">Über diese App</router-link>
    </p>
  </div>
  <div v-if="deferredPrompt && displayPrompt" class="container-fluid semi-transparent fixed-bottom p-3">
    <button @click.prevent="displayPrompt=false"
     class="btn btn-outline float-end"><i class="fas fa-times-circle" /></button>
    <button @click="installApp" class="btn btn-secondary">
      Als App installieren
    </button>
  </div>
  <div v-if="showIosPrompt" class="container-fluid semi-transparent fixed-bottom p-3">
    <button @click="dismissIosPrompt" class="btn btn-outline float-end">
      <i class="fas fa-times-circle" />
    </button>
    <p class="mb-1"><strong>App installieren</strong></p>
    <p class="mb-0 small">
      Tippe auf <span v-html="iosShareIcon"></span>
      <span v-if="isIOSChrome"> oben rechts,</span><span v-else> unten in Safari,</span>
      dann <strong>„Zum Home-Bildschirm"</strong>
    </p>
  </div>
  <br>
</default-layout>
</template>

<script>
// @ is an alias to /src
import VRuntimeTemplate from "v-runtime-template";
import DefaultLayout from '@/components/DefaultLayout.vue'
import EventNavbar from '@/components/EventNavbar.vue'

export default {
  name: 'HomeView',
  components: {
    VRuntimeTemplate, DefaultLayout, EventNavbar
  },
  data() {
    return {
      home_content: '',
      deferredPrompt: null,
      displayPrompt: true,
      showIosPrompt: false,
      isIOSChrome: false,
      iosShareIcon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="16" width="16" style="vertical-align:text-bottom"><path fill="#000000" d="M5.5 23c-0.4 0 -0.75 -0.15 -1.05 -0.45 -0.3 -0.3 -0.45 -0.65 -0.45 -1.05V8.775c0 -0.4 0.15 -0.75 0.45 -1.05 0.3 -0.3 0.65 -0.45 1.05 -0.45h4.225v1.5H5.5V21.5h13V8.775h-4.275v-1.5H18.5c0.4 0 0.75 0.15 1.05 0.45 0.3 0.3 0.45 0.65 0.45 1.05V21.5c0 0.4 -0.15 0.75 -0.45 1.05 -0.3 0.3 -0.65 0.45 -1.05 0.45H5.5Zm5.725 -7.675V3.9l-2.2 2.2 -1.075 -1.075L11.975 1 16 5.025l-1.075 1.075 -2.2 -2.2v11.425h-1.5Z" stroke-width="0.5"/></svg>`
    }
  },
  created() {
    let me = this
    if (navigator.onLine) {
      this.$api.get('/zpcard/').then((response) => {
        me.home_content = response.data.html
        localStorage.setItem('zpcard-home', me.home_content)
        me.extractCurrentEventShortName(me.home_content)
      }).catch(error => {
        console.log('fetch error.', error)
        me.home_content = localStorage.getItem('zpcard-home')
        if (me.home_content) me.extractCurrentEventShortName(me.home_content)
      })
    } else {
        me.home_content = localStorage.getItem('zpcard-home')
        if (me.home_content) me.extractCurrentEventShortName(me.home_content)
    }
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();
      this.deferredPrompt = event;
    })
    this.checkIosInstallPrompt()
  },

    methods: {
    extractCurrentEventShortName(html) {
      // Parse first router-link to="/<shortName>" from CMS HTML
      let match = html.match(/to="\/([a-zA-Z0-9_-]+)"/)
      if (match && match[1]) {
        this.$storage.setCurrentEventShortName(match[1])
      }
    },
    checkIosInstallPrompt() {
      const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent)
      const dismissed = localStorage.getItem('ios-install-dismissed')
      this.isIOSChrome = /CriOS/i.test(navigator.userAgent)
      this.showIosPrompt = isIOS && !dismissed
    },
    dismissIosPrompt() {
      localStorage.setItem('ios-install-dismissed', '1')
      this.showIosPrompt = false
    },
    installApp() {
      // Überprüfe, ob das deferredPrompt-Objekt verfügbar ist
      if (this.deferredPrompt) {
        // Fordere die Installation der App an
        this.deferredPrompt.prompt();
        // Warte auf das Ergebnis der Installation
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('Benutzer hat die Installation akzeptiert');
          } else {
            console.log('Benutzer hat die Installation abgelehnt');
          }
          // Setze das deferredPrompt-Objekt auf null, da es nur einmal verwendet werden kann
          this.deferredPrompt = null;
        });
      }
    },

    cacheImages(htmlContent) {
      // Create a temporary div element
      const tempDiv = document.createElement('div');

      // Set the innerHTML of the temporary div to your HTML content
      tempDiv.innerHTML = htmlContent;

      // Find all img elements within the temporary div
      const images = tempDiv.querySelectorAll('img');

      // Iterate over the images and memorize them on loading
      images.forEach(img => {
          caches.open('huhu').then( cache => {
            cache.add(img.src).then( () => {
            console.log(img.src, "cached ")
          });
        });
      })
    },

    loadImages(htmlContent) {
      // Create a temporary div element
      const tempDiv = document.createElement('div');

      // Set the innerHTML of the temporary div to your HTML content
      tempDiv.innerHTML = htmlContent;

      // Find all img elements within the temporary div
      const images = tempDiv.querySelectorAll('img');

      images.forEach(img => {
        caches.open('huhu').then(cache => {
          cache.match(img.src).then(response => {
            let blob = response.blob();
            img.src = URL.createObjectURL(blob);
            console.log('image created', img.src)
          })
        })
      })
    }
  }
}
</script>


<style scoped>
.semi-transparent {
  background-color: rgba(211, 211, 211, 0.9);
  position: fixed;
  bottom: 60px;
  left: 0;
  width: 100%;
}
</style>